import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import ProtectedRoute from './AdminProtectedRoutes';
import MainLayout from 'layout/MainLayout';
import { ProcurementProtectedRoute } from './DepartmentProtect';


const ProcurementDashboardPage = Loadable(lazy(() => import('views/pages/procurement')));
const InvoicesPage = Loadable(lazy(() => import('views/pages/procurement/Invoices')));
const CertificatesPage = Loadable(lazy(() => import('views/pages/procurement/Certificates')));
const CertificateDetailPage = Loadable(lazy(() => import('views/pages/qs/CertificateDetailPage')));
const RequisitionsPage = Loadable(lazy(() => import('views/pages/procurement/Requisitions')));
const RFQPage = Loadable(lazy(() => import('views/pages/procurement/RFQ')));
const OrderBookPage = Loadable(lazy(() => import('views/pages/procurement/OrderBook')));
const DeliveryNotesPage = Loadable(lazy(() => import('views/pages/procurement/DeliveryNote')));
const SiteReportsPage = Loadable(lazy(() => import('views/pages/procurement/SiteInspections')));
const ReportsPage = Loadable(lazy(() => import('views/pages/procurement/Analytics')));
const ProjectReportForm = Loadable(lazy(() => import('ui-component/reports/report-form')));
const ProcProjects = Loadable(lazy(() => import('views/pages/procurement/ProcProjects')));
const ProcProjectDetail = Loadable(lazy(() => import('views/pages/procurement/ProcProjectDetails')));
const ProcTeamPage = Loadable(lazy(() => import('views/pages/procurement/ProcTeam')));
const ProcMemberProfile = Loadable(lazy(() => import('views/pages/procurement/ProcMemberProfile')));
const AccountSettings = Loadable(lazy(() => import('ui-component/account-settings')));
const AuditLogsPage = Loadable(lazy(() => import('views/pages/dashbord/utilities/AuditLog')));

// ==============================|| MAIN ROUTING ||============================== //

const ProcumentRoutes = {
    path: '/procurement',
    element: (
        <ProcurementProtectedRoute>
            <MainLayout />
        </ProcurementProtectedRoute>
    ),
    children: [
        {
            path: '/procurement',
            element: <Navigate to="/procurement/dashboard" replace />
        },
        {
            path: '/procurement/dashboard',
            element: <ProcurementDashboardPage />
        },
        {
            path: '/procurement/certificates',
            element: <CertificatesPage />
        },
        {
            path: '/procurement/certificates/:id',
            element: (
                <ProtectedRoute
                    permissions={['certificates.read', 'certificates.update', 'certificates.review_qs', 'certificates.approve_qs']}
                >
                    <CertificateDetailPage />
                </ProtectedRoute>
            )
        },
        {
            path: '/procurement/projects/:sectorId/:slug',
            element: <ProcProjects />
        },

        {
            path: '/procurement/projects/:id',
            element: (
                <ProtectedRoute permissions={['projects.read']}>
                    <ProcProjectDetail />
                </ProtectedRoute>
            )
        },
        {
            path: '/procurement/requisitions',
            element: <RequisitionsPage />
        },
        {
            path: '/procurement/rfqs',
            element: <RFQPage />
        },
        {
            path: '/procurement/orderbook',
            element: <OrderBookPage />
        },
        {
            path: '/procurement/delivery',
            element: <DeliveryNotesPage />
        },
        {
            path: '/procurement/invoices',
            element: <InvoicesPage />
        },
        {
            path: '/procurement/site-reports',
            element: <SiteReportsPage />
        },
        {
            path: '/procurement/analytics',
            element: <ReportsPage />
        },
        {
            path: '/procurement/team',
            element: <ProcTeamPage />
        },
        {
            path: '/procurement/team/:id',
            element: <ProcMemberProfile />
        },
        {
            path: '/procurement/funds/:fundId',
            element: <ProjectReportForm />
        },
        {
            path: '/procurement/account_settings',
            element: <AccountSettings />
        },
        {
            path: '/procurement/audit-logs',
            element: <AuditLogsPage />
        }
    ]
};

export default ProcumentRoutes;
